export enum TourType {
  Regular = 'regular',
  Conference = 'conference',
  Game = 'game',
  ECommerce = 'ecommerce',
  Ticket = 'ticket',
  Kiosk = 'kiosk'
}

export enum ChapterType {
  Tag = 'tag',
  Polygon = 'polygon',
  VSItem = 'vsItem',
  VSImage = 'vsImage',
  VSVideo = 'vsVideo'
}

export enum TagType {
  None = 'none',
  // Text = 'text',
  // Image = 'image',
  // Gallery = 'gallery',
  Music = 'music',
  // Video = 'video',
  Popup = 'popup',
  Iframe = 'iframe',
  Tab = 'tab',
  Panorama = 'panorama',
  Menu = 'menu',
  Matterport = 'matterport',
  MatterportInstant = 'matterport-instant',
  Treedis = 'treedis',
  VideoChat = 'video-chat',
  ConferenceChat = 'conference-chat',
  Navigation = 'navigation'
}
